import { render } from "./FeaturesList.vue?vue&type=template&id=4d21f231"
import script from "./FeaturesList.vue?vue&type=script&lang=js"
export * from "./FeaturesList.vue?vue&type=script&lang=js"

import "./FeaturesList.vue?vue&type=style&index=0&id=4d21f231&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__